import { FC } from 'react';
import { createFundDataModel } from '../../../data-models/fund.data-model';
import { IFinancingBoard, IFinancingRights } from '../../../data-models/round-governance.data-model';
import { RoundGovernanceSectionView } from './RoundGovernanceSection';
import { fixtureBoardFinancing, fixtureGovernanceTerms, fixtureRights } from './roundGovernance.fixtures';

const PREVIEW_FUND = 'Growth Fund IV';
const PREVIEW_ROUND_ID = 0;

export const PREVIEW_FUNDS = [createFundDataModel({ id: -1, name: PREVIEW_FUND })];

/** A well-extracted round: 17 of 18 terms known, our fund on the board with information and pro rata rights. */
export const PREVIEW_RIGHTS: IFinancingRights = (() => {
  const [ours, lead] = fixtureRights(PREVIEW_ROUND_ID).financings[0].investors;
  return {
    ...fixtureRights(PREVIEW_ROUND_ID).financings[0],
    terms: fixtureGovernanceTerms({
      protectiveSectionsReference: 'Section 5.3',
      dragAlong: true,
      payToPlay: false,
      antiDilutionRights: true,
      redemptionRights: false,
      cumulativeDividends: false,
      rofrAndCosaleAgreement: true,
      registrationRightsForPreferred: true,
      standardProRataFormulation: true,
      proRataRightsForMajorInvestors: true,
      proRataRightsForAll: false,
      informationRightsForMajorInvestors: true,
      informationRightsForAll: null,
      employeeVestingProtocol: true,
    }),
    investors: [
      { ...ours, fundName: PREVIEW_FUND, fundId: 'fund-preview', hasProRataRights: true },
      { ...lead, fundName: 'Ridgeback Partners' },
    ],
  };
})();

export const PREVIEW_BOARD: IFinancingBoard = fixtureBoardFinancing({
  totalBoardSize: 5,
  derivedSeatCount: 4,
  seats: [
    { seatStatus: 'FILLED', memberName: 'Elena Marsh', firm: PREVIEW_FUND, fundId: 'fund-preview' },
    { seatStatus: 'FILLED', memberName: 'Marcus Hale', firm: 'Ridgeback Partners', fundId: null },
    { seatStatus: 'FILLED', memberName: 'Priya Natarajan', firm: 'Priya Natarajan', fundId: null },
    { seatStatus: 'FILLED', memberName: 'Tom Okafor', firm: 'Tom Okafor', fundId: null },
  ],
  observers: [{ name: 'Dana Whitfield', firm: 'Bluewater Capital', fundId: null }],
});

/** Sample-data stand-in for the Governance & Investor Rights card while it is frosted. */
export const RoundGovernancePreview: FC = () => (
  <RoundGovernanceSectionView
    boardFinancings={[PREVIEW_BOARD]}
    rightsFinancings={[PREVIEW_RIGHTS]}
    funds={PREVIEW_FUNDS}
    position={{ holdingFundNames: [PREVIEW_FUND], hasLots: true, loading: false }}
  />
);
